<template>
  <search-bar :search="search" class-btn-search="btn btn-primary icon-magnifier form-group right" ref="search">
    <div class="row">
      <div class="form-group col-md-4 col-xs-12 col-sm-12">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span for="profissional" class="input-group-text" style="width: 95px;">Profissional</span>
          </div>
          <select id="profissional" class="form-control" v-model="search.usuario_id" style="width: calc(100% - 95px);">
            <option value="">Selecione...</option>
            <option v-for="usuario of dados.usuarios" v-bind:key="usuario.id" :value="usuario.id">{{ usuario.nome }} - {{ usuario.email }}</option>
          </select>
        </div>
      </div>

      <div class="form-group col-md-4 col-xs-12 col-sm6">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="profissional" style="width: 90px;">Data Inicial</span>
          </div>
          <date-picker input-class="form-control"
                        v-model="search.data_inicial"
                        lang="pt-br"
                        format="DD/MM/YYYY"
                        style="width: calc(100% - 90px);">
          </date-picker>
        </div>
      </div>

      <div class="form-group col-md-4 col-xs-12 col-sm6">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="profissional" style="width: 90px;">Data Final</span>
          </div>
          <date-picker input-class="form-control"
                        v-model="search.data_final"
                        lang="pt-br"
                        format="DD/MM/YYYY"
                        style="width: calc(100% - 90px);">
          </date-picker>
        </div>
      </div>
    </div>
  </search-bar>
</template>

<script>
  import { SearchBar } from 'metawesome-datatable';
  import Uteis from '@/mixins/utils.js';
  import DatePicker from 'vue2-datepicker';

  export default {
    components: {
      SearchBar,
      DatePicker,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        search: {
          usuario_id: '',
          data_inicial: '',
          data_final: '',
        },
        dados: {
          usuarios: [],
        },
      };
    },

    mounted() {
      this.$refs.search.$on('filter-set', (filter) => {
        this.$emit('filter-set', filter);
      });

      this.filtrar();
      this.carregarProfissionais();
    },

    methods: {
      filtrar() {
        this.$emit('filter-set', this.search);
      },

      async carregarProfissionais() {
        try {
          const { data: response } = await this.$http.get('/v-usuario/list');

          this.dados.usuarios = response.usuarios;
        } catch(e) {
          this.notificar('Ocorreu um erro ao carregar os Usuários', 'liberacao-horas');
        }
      },
    },
  };
</script>
